<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="details_wrap container">
      <titleConfig
        :title="langSet == 'cn' ? '新闻详情' : 'News Details'"
        :type="2"
      ></titleConfig>
      <div
        class="content"
        v-html="
          langSet == 'cn'
            ? details.content
            : details.en_content
            ? details.en_content
            : details.content
        "
      ></div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import { articleDetail } from "@/api/api";
export default {
  // 配置title
  metaInfo() {
    return {
      title: "新闻详情",
    };
  },
  components: {
    top,
    bottom,
    titleConfig,
  },
  data() {
    return {
      langSet: "",
      id: "",
      details: {},
    };
  },
  created() {},
  mounted() {
    this.langSet = this.$language;
    this.id = this.$route.query.id;
    //25.9.16 获取新闻资讯 dxm
    this.getDetails(this.id);
  },
  methods: {
    async getDetails(id) {
      let data = {
        id,
      };
      const res = await articleDetail(data);
      this.details = res.data;
    },
    currentChange(e) {
      this.pageNo = e;
      this.getList();
    },
    sizeChange(e) {
      this.pageSize = e;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.details_wrap {
  padding-top: 80px;
  /deep/ p img {
    display: inline-block;
    max-width: 100%;
  }
  .content {
    padding: 30px 30px 100px;
  }
}
@media only screen and (max-width: 767px) {
  .details_wrap {
    padding-top: 0;
    .content {
      padding: 0.3rem 0 1rem;
    }
  }
}
</style>